module.exports = __webpack_public_path__ + "img/22.2ace6e00.jpg";